import { CoordinatorService } from "./coordinator.service"

export class AiLlmResponse {
    type: "Gemini" = "Gemini"

    constructor(private coords: CoordinatorService, params: any) {
        if (params.candidates && params.usageMetadata)
            this.type = "Gemini"

        switch (this.type) {
            case "Gemini": 
                this._processGemini(params)
                break
        }
    }

    private _processGemini(params: any) {
        console.log("PROCESSING GEMINI", params)
        params.candidates[0]?.content.parts.forEach((x: any) => {
            console.log(12232, x.text)
            console.log(JSON.parse(x.text.substring(
                    x.text.indexOf("{"),x.text.lastIndexOf("}")+1)))
        })
    }
}
